// extracted by mini-css-extract-plugin
export default {"container":"Box_container__PCBuM","Box":"Box_Box__oI6BW","image":"Box_image__PEESC","title":"Box_title__pMTZK","desc":"Box_desc__aCQdg"};